import { createClient } from '@supabase/supabase-js';
import { createAuthFetch } from './utils/authFetch';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// The request gate + one quiet retry on an expired token (utils/authFetch — read its header before changing this).
// `client` is assigned below; the gate only calls getSession at request time, long after.
// eslint-disable-next-line prefer-const
let client;
const debugFailRefresh = () => {
  if (process.env.NODE_ENV === 'production') return false;   // the forced failure exists in development only
  try { return localStorage.getItem('wh_debug_fail_refresh') === '1'; } catch (e) { return false; }
};
const gate = createAuthFetch({
  baseFetch: (...args) => fetch(...args),
  getSession: async () => (await client.auth.getSession()).data.session,
  debug: debugFailRefresh,
});

client = createClient(supabaseUrl, supabaseAnonKey, { global: { fetch: gate.fetch } });
client.auth.onAuthStateChange((_event, session) => gate.setSignedIn(!!session));

if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  // Development: trigger a token refresh on demand, to exercise the forced failure above.
  window.__whAuthDebug = { refresh: () => client.auth.refreshSession(), gateState: gate.state };
}

export const supabase = client;
